module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/3-5-2-96bd9b8273eb49986f99ced41e347a66.png";